import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CustomBreadcrumb, DataTable, PageActions } from '../../../../fgs';
import DefaultPageContext from '../../../../fgs/context/DefaultPageContext';
import { allDocumentsToolbarActions } from '../utils/';
import { setupAllDocumentsToolbarActions } from "../componentFunctions";
import { documentHeaders } from "../../../formHeaders";
import ModalContext from '../../../../fgs/context/ModalContext';
import RequestContext from '../../../../fgs/context/RequestContext';
import EditDirectoryModalContent from "../components/EditDirectoryModalContent";
import RemoveItemsModalContent from "../components/RemoveItemsModalContent";
import * as Feather from 'react-feather';

// services
import {
  deleteDocuments,
  deleteDirectories,
  getDirectoriesAndDocuments,
  downloadDocuments,
  createDownloadRequest
} from '../../../../services/api';
import { listHasValidItens } from "../../../../fgs/helpers/collectionsHelper";
import { setUrlParams, retrieveDefaultParams } from '../../../../services/urlParams';

const AllDocuments = () => {
  const history = useHistory();
  const requestContext = useContext(RequestContext);
  const modalContext = useContext(ModalContext);
  const permission = requestContext.loggedUser?.permissions?.find(p => p.page === 'DocumentListPage') || [];
  const [datasource, setDatasource] = useState({});
  const [selectedItems, setSelectedItems] = useState([]);
  const [dirHistory, setDirHistory] = useState([]);
  const [showAdvancedFilter, setShowAdvancedFilter] = useState(false);

  const fetchDocuments = async (context) => {
    setUrlParams.bind({ history })({ ...context });
    getDirectoriesAndDocuments().then((response) => {
      setDatasource(response.data);
      setDirHistory(response.data.dirHistory);
    });
  };

  const doDeleteDocuments = async (ids, type) => {
    if (!listHasValidItens(ids) || !type) return;
    
    if (type === 'dir') {
      deleteDirectories(ids).then(() => {
        setSelectedItems([]);
        fetchDocuments(retrieveDefaultParams());
      });
    } else if (type === 'doc') {
      deleteDocuments(ids).then(() => {
        setSelectedItems([]);
        fetchDocuments(retrieveDefaultParams());
      });
    }
  };

  const doDownloadDocuments = async (ids) => {
    if (!listHasValidItens(ids)) return;

    createDownloadRequest(requestContext.loggedUser.id)
      .then(res => {
        downloadDocuments(ids, res.data.requestId);
      });
  };

  const onRowClick = id => fetchDocuments({ parentId: id });
  const onRowClickCondition = row => row.type === 'dir';

  const toggleAdvancedFilter = () => setShowAdvancedFilter(!showAdvancedFilter);

  const openEditModal = (e) => {
    if(!e?.target?.id) return;

    const content = {
      component: EditDirectoryModalContent,
      props: {
        fetchDocuments,
        directoryId: e.target.id
      }
    };
    modalContext.setContent(content);
    modalContext.toggle();
  };

  const openRemoveItemModal = (e) => {
    if(!e?.target?.id) return;

    const content = {
      component: RemoveItemsModalContent,
      props: {
        doDeleteDocuments,
        singleItem: {
          id: e.target.id, 
          type: e.target.dataset.customColumn
        }
      }
    };
    modalContext.setContent(content);
    modalContext.toggle();    
  };

  useEffect(() => {
    fetchDocuments(retrieveDefaultParams());
    return () => {
      setDatasource({});
      setDirHistory([]);
    };
  }, []);


  const pageTableSetup = {
    header: {
      actionCol: true,
    },
    body: {
      actionCol: {
        actions: [
          {
            conditionColumn: {
              name: 'type',
              value: 'dir'
            },
            props: {
              onClick: openEditModal,
              style: { marginRight: '10px' }
            },
            icon: Feather.Edit,
            permission: 'rename'
          },
          {
            props:
            {
              onClick: (e) => e.target.id && doDownloadDocuments([e.target.id]),
              style: { marginRight: '10px' }
            },
            icon: Feather.Download,
            permission: 'download'
          },
          {
            customAttr: 'type',
            props: {
              onClick: (e) => openRemoveItemModal(e)
            },
            icon: Feather.Trash,
            permission: 'remove'
          }
        ].filter(act => permission.actions.some(action => (act.permission === action) || action === 'all'))
      },
      tr: {
        customClass: 'default-action-row',
        customClassCondition: (row) => row.type === 'dir'
      }
    }
  };

  const providerValues = {
    setSelectedItems,
    selectedItems
  };

  const setupParams = {
    context: modalContext,
    selectedItems,
    toggleAdvancedFilter,
    doDeleteDocuments,
    doDownloadDocuments,
    fetchDocuments
  };
  setupAllDocumentsToolbarActions(setupParams);

  return (
    <DefaultPageContext.Provider value={providerValues}>
      <CustomBreadcrumb items={dirHistory} updateDatasource={fetchDocuments} />
      <DataTable
        showAdvancedFilter={showAdvancedFilter}
        datasource={datasource}
        headers={documentHeaders}
        onRowClick={onRowClick}
        onRowClickCondition={onRowClickCondition}
        pageActions={{ component: PageActions, actions: allDocumentsToolbarActions }}
        updateDatasource={fetchDocuments}
        customTableSetup={pageTableSetup} />
    </DefaultPageContext.Provider>
  );
};

export default AllDocuments;